import { useEffect } from "react";
import { useTolgee } from "@tolgee/react";
import { userStore } from "../zustand/globalStore";
import { useAuth } from "../contextsAndHooks/AuthContext";
import { interfaceAuthorityFromSettings } from "./interfaceLanguagePreference";
import { bindInterfaceLanguageRuntime, interfaceLanguageController } from "./interfaceLanguageRuntime";
import { connectNativeInterfaceLanguage } from "./connectNativeInterfaceLanguage";
import { trackErrorWhenLoaded } from "../utils/analytics/track-error-when-loaded";

/**
 * Account preference wins after auth. System mode follows the full device list;
 * effective-language writes use the same narrow, revision-checked owner API.
 */
export function AppLanguageSync() {
  const tolgee = useTolgee();
  const { authenticationLoading } = useAuth();
  const user = userStore(state => state.currentUser);
  const accountId = user?.id ?? null;
  const preference = user?.user_settings?.app_language_preference;
  const revision = user?.user_settings?.app_language_preference_revision;

  useEffect(() => bindInterfaceLanguageRuntime(tolgee), [tolgee]);

  useEffect(() => {
    if (authenticationLoading) return;
    void interfaceLanguageController.reconcileAccount(accountId,
      accountId ? interfaceAuthorityFromSettings(userStore.getState().currentUser?.user_settings) : null);
  }, [authenticationLoading, accountId, preference, revision]);

  useEffect(() => {
    if (authenticationLoading) return;
    return connectNativeInterfaceLanguage({ controller: interfaceLanguageController, accountId,
      onError: error => trackErrorWhenLoaded(error, { scope: "native-interface-language" }) });
  }, [authenticationLoading, accountId]);

  useEffect(() => {
    const languageChanged = () => { void interfaceLanguageController.refreshSystemLanguage(); };
    const online = () => { void interfaceLanguageController.retry(); };
    window.addEventListener("languagechange", languageChanged);
    window.addEventListener("online", online);
    return () => {
      window.removeEventListener("languagechange", languageChanged);
      window.removeEventListener("online", online);
    };
  }, []);

  return null;
}
